import React from "react";

const INLINE_RE = /\*\*([^*]+)\*\*|\*([^*]+)\*|`([^`]+)`|\[([^\]]+)\]\(([^)\s]+)\)/g;

function renderInline(text) {
  const nodes = [];
  let last = 0;
  let key = 0;
  let m;
  INLINE_RE.lastIndex = 0;
  while ((m = INLINE_RE.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[1] !== undefined) {
      nodes.push(<strong key={key++}>{m[1]}</strong>);
    } else if (m[2] !== undefined) {
      nodes.push(<em key={key++}>{m[2]}</em>);
    } else if (m[3] !== undefined) {
      nodes.push(<code key={key++} className="chat-inline-code">{m[3]}</code>);
    } else if (m[4] !== undefined) {
      nodes.push(
        <a key={key++} href={m[5]} target="_blank" rel="noopener noreferrer">
          {m[4]}
        </a>
      );
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

function renderBlocks(text) {
  const lines = text.split(/\r?\n/);
  const blocks = [];
  let i = 0;
  let key = 0;

  while (i < lines.length) {
    const trimmed = lines[i].trim();
    if (!trimmed) {
      i++;
      continue;
    }

    if (/^```/.test(trimmed)) {
      const codeLines = [];
      i++;
      while (i < lines.length && !/^```/.test(lines[i].trim())) {
        codeLines.push(lines[i]);
        i++;
      }
      i++;
      blocks.push(
        <pre key={key++} className="chat-code">
          <code>{codeLines.join("\n")}</code>
        </pre>
      );
      continue;
    }

    const heading = trimmed.match(/^(#{1,3})\s+(.*)$/);
    if (heading) {
      const level = heading[1].length;
      blocks.push(
        <p key={key++} className={`chat-h chat-h${level}`}>
          {renderInline(heading[2])}
        </p>
      );
      i++;
      continue;
    }

    if (/^(-{3,}|\*{3,})$/.test(trimmed)) {
      blocks.push(<hr key={key++} />);
      i++;
      continue;
    }

    const bulletMatch = trimmed.match(/^([-*])\s+/);
    const orderedMatch = trimmed.match(/^(\d+[.)])\s+/);
    if (bulletMatch || orderedMatch) {
      const items = [];
      const isOrdered = Boolean(orderedMatch);
      while (i < lines.length) {
        const t = lines[i].trim();
        const nextBullet = /^[-*]\s+/.test(t);
        const nextOrdered = /^\d+[.)]\s+/.test(t);
        if (isOrdered ? nextOrdered : nextBullet) {
          items.push(t.replace(isOrdered ? /^\d+[.)]\s+/ : /^[-*]\s+/, ""));
          i++;
        } else if (!t) {
          break;
        } else {
          items[items.length - 1] += " " + t;
          i++;
        }
      }
      blocks.push(
        isOrdered ? (
          <ol key={key++}>
            {items.map((it, j) => (
              <li key={j}>{renderInline(it)}</li>
            ))}
          </ol>
        ) : (
          <ul key={key++}>
            {items.map((it, j) => (
              <li key={j}>{renderInline(it)}</li>
            ))}
          </ul>
        )
      );
      continue;
    }

    const para = [trimmed];
    i++;
    while (i < lines.length) {
      const t = lines[i].trim();
      if (!t) break;
      if (/^#{1,3}\s+/.test(t) || /^```/.test(t) || /^[-*]\s+/.test(t) || /^\d+[.)]\s+/.test(t)) break;
      para.push(t);
      i++;
    }
    blocks.push(<p key={key++}>{renderInline(para.join(" "))}</p>);
  }

  return blocks;
}

export default function Markdown({ text }) {
  return <div className="chat-markdown">{renderBlocks(text)}</div>;
}
